module.exports = __webpack_public_path__ + "img/canyon_brown_ba_detail_rsh2(1).d36dde9e.jpg";